export const aiSubmissionText = {
  promptFailed: {
    key: 'ai_publish_prompt_failed',
    fallback: { en: 'Prompt creation failed', he: 'יצירת הפרומפט נכשלה' },
  },
  promptRetry: {
    key: 'ai_publish_prompt_retry',
    fallback: { en: 'Could not register the prompt. Please try again.', he: 'לא ניתן לשמור את הפרומפט. נסו שוב.' },
  },
  taskFailed: { key: 'ai_publish_task_failed', fallback: { en: 'Task creation failed', he: 'יצירת המשימה נכשלה' } },
  taskRetry: {
    key: 'ai_publish_task_retry',
    fallback: { en: 'Could not create the task. Please try again.', he: 'לא ניתן ליצור את המשימה. נסו שוב.' },
  },
  briefingFailed: {
    key: 'ai_publish_briefing_failed',
    fallback: { en: 'Briefing pop creation failed', he: 'יצירת תדריך ה-AI נכשלה' },
  },
  briefingPartial: {
    key: 'ai_publish_briefing_partial',
    fallback: {
      en: 'Task “{title}” was created, but its AI briefing could not be created.',
      he: 'המשימה ״{title}״ נוצרה, אך לא ניתן ליצור את תדריך ה-AI שלה.',
    },
  },
  jobFailed: { key: 'ai_publish_job_failed', fallback: { en: 'Job scheduling failed', he: 'תזמון הפעולה נכשל' } },
  briefingJobPartial: {
    key: 'ai_publish_briefing_job_partial',
    fallback: {
      en: 'Task “{title}” and its AI briefing were created, but the briefing could not be scheduled.',
      he: 'המשימה ״{title}״ ותדריך ה-AI שלה נוצרו, אך לא ניתן לתזמן את התדריך.',
    },
  },
  actionFailed: {
    key: 'ai_publish_action_failed',
    fallback: { en: 'Action pop creation failed', he: 'יצירת פופ הפעולה נכשלה' },
  },
  actionPartial: {
    key: 'ai_publish_action_partial',
    fallback: {
      en: 'Task “{title}” was created, but its action pop could not be created.',
      he: 'המשימה ״{title}״ נוצרה, אך לא ניתן ליצור את פופ הפעולה שלה.',
    },
  },
  actionJobFailed: {
    key: 'ai_publish_action_job_failed',
    fallback: { en: 'Action pop job scheduling failed', he: 'תזמון פופ הפעולה נכשל' },
  },
  actionJobPartial: {
    key: 'ai_publish_action_job_partial',
    fallback: {
      en: 'Task “{title}” and its action pop were created, but the action pop could not be scheduled.',
      he: 'המשימה ״{title}״ ופופ הפעולה שלה נוצרו, אך לא ניתן לתזמן את פופ הפעולה.',
    },
  },
  setupIncomplete: {
    key: 'ai_publish_setup_incomplete',
    fallback: { en: 'AI setup incomplete', he: 'הגדרת ה-AI לא הושלמה' },
  },
  stagePartial: {
    key: 'ai_publish_stage_partial',
    fallback: {
      en: 'Task “{title}” was created, but its {stage} could not be completed.',
      he: 'המשימה ״{title}״ נוצרה, אך לא ניתן להשלים את {stage}.',
    },
  },
  unexpectedRetry: {
    key: 'ai_publish_unexpected_retry',
    fallback: { en: 'An unexpected error occurred. Please try again.', he: 'אירעה שגיאה בלתי צפויה. נסו שוב.' },
  },
  briefingStage: { key: 'ai_publish_briefing_stage', fallback: { en: 'AI briefing', he: 'תדריך ה-AI' } },
  briefingJobStage: {
    key: 'ai_publish_briefing_job_stage',
    fallback: { en: 'AI briefing schedule', he: 'תזמון תדריך ה-AI' },
  },
  actionStage: { key: 'ai_publish_action_stage', fallback: { en: 'action pop', he: 'פופ הפעולה' } },
  actionJobStage: {
    key: 'ai_publish_action_job_stage',
    fallback: { en: 'action pop schedule', he: 'תזמון פופ הפעולה' },
  },
}
